import React from 'react';

/**
 * StorySection - Story-led learning component
 *
 * Displays a grounded, contextual story before technical content.
 * Stories show WHY a concept matters in real life.
 *
 * Design principles:
 * - Third person, conversational tone
 * - 100-150 words maximum
 * - Local contexts (spaza shops, taxi ranks, community spaces)
 * - Never motivational fluff - always structural truth
 */
function StorySection({ story }) {
  if (!story || !story.content) {
    return null;
  }

  return (
    <div className="mb-6 p-6 bg-slate-800/50 border-l-4 border-amber-500 rounded-r-lg">
      {/* Story header - subtle, not attention-grabbing */}
      <div className="flex items-center gap-2 mb-3">
        <span className="text-amber-400 text-sm font-medium">Why This Matters</span>
      </div>

      {/* Story content - readable, calm spacing */}
      <div className="text-slate-200 leading-relaxed text-base space-y-3">
        {story.content.split('\n\n').map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}
      </div>

      {/* Optional: Story attribution (for when stories come from real community members) */}
      {story.context && (
        <div className="mt-4 pt-3 border-t border-slate-700/50">
          <p className="text-slate-400 text-sm italic">{story.context}</p>
        </div>
      )}
    </div>
  );
}

export default StorySection;
